import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "./button";
import { Card, CardContent } from "./card";
import { toast } from "react-toastify";
import InputField from "./InputField";
import SelectField from "./SelectField";
import TextAreaField from "./TextAreaField";
import SelectSimple from "./SelectSimple";

const TiposMantenimiento = ["Preventivo", "Correctivo", "Calibración"];

const AlarmaModal = ({ alarma, onClose, onSave }) => {
  const isEdit = Boolean(alarma?.cronograma?._id);

  const [form, setForm] = useState({
    fechaProgramada: alarma?.cronograma?.fechaProgramada
      ? new Date(alarma.cronograma.fechaProgramada).toISOString().slice(0, 16)
      : "",
    tipo: alarma?.cronograma?.tipo || "Preventivo",
    responsable: alarma?.cronograma?.personaAsignada?._id || "",
    observaciones: alarma?.cronograma?.observaciones || "",
  });
  const [personas, setPersonas] = useState([]);
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    axios
      .get(`${API}/users/resp`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setPersonas(res.data))
      .catch(() => {});
  }, [API, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fechaProgramada) {
      toast.error("La fecha es obligatoria");
      return;
    }
    if (!form.responsable) {
      toast.error("El responsable es obligatorio");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        equipo: alarma.equipo._id,
        fechaProgramada: form.fechaProgramada,
        tipo: form.tipo,
        responsable: form.responsable,
        observaciones: form.observaciones,
      };

      if (isEdit) {
        await axios.put(`${API}/cronograma/${alarma.cronograma._id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Programación actualizada");
      } else {
        await axios.post(`${API}/cronograma`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Mantenimiento programado");
      }
      onSave();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Error al guardar");
    } finally {
      setLoading(false);
    }
  };

  const eq = alarma?.equipo;
  const equipoLabel = eq
    ? `[${eq.serial || "—"}] ${eq.marca?.name || ""} ${eq.modelo?.name || ""}`
    : "";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl w-full max-w-lg shadow-xl">
        <Card>
          <CardContent className="p-6">
            <div className="flex justify-between items-start mb-5">
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {isEdit ? "Editar programación" : "Programar mantenimiento"}
                </h3>
                <p className="text-sm text-gray-500 mt-0.5 font-mono">
                  {equipoLabel}
                </p>
                {eq?.cliente?.name && (
                  <p className="text-xs text-gray-400 mt-0.5">
                    {eq.cliente.name}
                    {eq.area?.name && ` · ${eq.area.name}`}
                  </p>
                )}
              </div>
              <button
                type="button"
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 text-2xl leading-none font-light"
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <InputField
                label="Fecha programada *"
                type="datetime-local"
                name="fechaProgramada"
                value={form.fechaProgramada}
                onChange={handleChange}
                required
              />

              <SelectSimple
                label="Tipo de mantenimiento *"
                name="tipo"
                value={form.tipo}
                onChange={handleChange}
                options={TiposMantenimiento}
              />

              <SelectField
                label="Responsable *"
                name="responsable"
                value={form.responsable}
                onChange={handleChange}
                options={personas}
                displayFn={(p) => `${p.name} (${p.email})`}
              />

              <TextAreaField
                label="Observaciones"
                name="observaciones"
                value={form.observaciones}
                onChange={handleChange}
              />

              <div className="flex justify-end gap-2 pt-2">
                <Button type="button" onClick={onClose} variant="outline">
                  Cancelar
                </Button>
                <Button type="submit" disabled={loading}>
                  {loading ? "Guardando..." : "Guardar"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AlarmaModal;
